import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclNavbarSecondaryService, CclDrawerService } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";

@Component({
    selector: "app-layout-page",
    templateUrl: "./layout-page.view.html",
    styleUrls: []
})
export class LayoutPageView implements AfterViewInit, OnInit {
    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        private drawerService: CclDrawerService,
        public sharedService: SharedService
    ) {}

    ngAfterViewInit(): void {}

    ngOnInit() {
        this.navSecondaryService.sectionLabel = "Design Elements";
    }

    navigateTo(item) {
        this.sharedService.catalogNavigateHelper("admin", "/catalog/layout/" + item);
    }

    openConfigDrawer(item) {
        this.drawerService.toggleDrawer("small");
        let url = "";
        if (item == "filter") {
            url = "config-drawer/filter";
        } else if (item == "catalog") {
            url = "config-drawer/session-catalog";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
